import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useKeycloak } from '@react-keycloak/web'

import { AppAuthProvider } from 'src/middleware'
import Loader from 'src/components/shared/loader'
import logo from 'src/assets/images/favicon.png'

const LoginPage: React.FC = () => {
    const navigate = useNavigate();
    const { authProvider } = AppAuthProvider()
    const { keycloak, initialized } = useKeycloak()

    React.useEffect(() => {
        if (initialized && keycloak.authenticated) {
            navigate('/');
        }
    }, [initialized, keycloak.authenticated, navigate]);

    return (
        <div className="h-screen w-full flex justify-center items-center relative overflow-hidden bg-gradient-to-br from-[#1a4d3e] to-[#0d2e24]">
            {!initialized ? <Loader /> :
                <div className="min-h-screen w-full flex flex-col items-center justify-between relative overflow-hidden bg-gradient-to-br from-[#1a4d3e] to-[#0d2e24] p-8">
                    <div className="absolute top-20 left-10 w-72 h-72 bg-[#7ed957] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob" />
                    <div className="absolute top-40 right-10 w-72 h-72 bg-[#5fb83d] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000" />
                    <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-[#4a9b2e] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000" />

                    <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.05)_1px,transparent_1px)] bg-[size:3rem_3rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_70%,transparent_110%)]" />
                    <div className="mt-4 flex items-center gap-1">
                      <img src={logo} width={25} height={25} alt='logo'/>   <h1 className="text-2xl font-semibold text-white">TeclaVerde</h1>
                    </div>
                    {!keycloak.authenticated && (
                        <button type="button" className='h-8 rounded-md z-40 text-sm w-28 bg-green-600 text-white hover:bg-green-700'
                            onClick={() => authProvider.login()}>
                            Login
                        </button>
                    )}
                    <div className="mt-4">
                        <p className="text-sm text-white">Version: {import.meta.env.VITE_APP_VERSION || '1.0.0'}</p>
                    </div>
                </div>}
        </div>
    )
}

export default LoginPage
